module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Medium-Hestia.679643f.woff";